export type OriginKeyword =
  | 'alegra-api'
  | 'educacion'
  | 'pos-boutiques'
  | 'partner-pos-wompi'
  | 'alegra-pos'
  | 'alegra-only-invoicing'
  | 'alegra-invoicing'
  | 'alegra-fe'
  | 'alegra-resico'
  | 'alegra-payroll'

export type AlliancesOriginKeyword =
  | 'partner-ccb'
  | 'partner-nequi'
  | 'partner-payu'
  | 'partner-payu-mex'
  | 'partner-visa-per'
  | 'partner-visa-col'
  | 'partner-visa-dom'
  | 'partner-visa-cri'
  | 'partner-visa-mex'
  | 'alzmasterc'

export type OnboardingType =
  | 'generic'
  | 'accountant'
  | 'resico'
  | 'education'
  | 'migration'
  | 'health'
  | 'onlyInvoicing'

export type IcpRegisterFlow = 'default' | 'withIcpOnly' | 'withProduct' | 'productOnly' | 'invalid'

export const ICP_REGISTER_STEP = {
  REGISTER: 0,
  CHOOSE_ICP: 1,
  RECOMMENDATION: 2,
} as const

export type IcpRegisterStep = (typeof ICP_REGISTER_STEP)[keyof typeof ICP_REGISTER_STEP]

export type IcpRegisterPendingStep =
  | typeof ICP_REGISTER_STEP.CHOOSE_ICP
  | typeof ICP_REGISTER_STEP.RECOMMENDATION

export const Icp = {
  SMALL_BUSINESS: 'SMALL_BUSINESS',
  ACCOUNTANT: 'ACCOUNTANT',
  MID_BUSINESS: 'MID_BUSINESS',
  STUDENT: 'STUDENT',
} as const

export const IcpProduct = {
  POS: 'POS',
  SF: 'SF',
  AC: 'AC',
  NOMINA: 'NOMINA',
} as const

export type IcpValue = (typeof Icp)[keyof typeof Icp]
export type IcpProductValue = (typeof IcpProduct)[keyof typeof IcpProduct]

export const ICP_NO_ICP = 'NO_ICP' as const

export type IcpRegisterVariantIcp = IcpValue | typeof ICP_NO_ICP
export type IcpRegisterVariantProduct = IcpProductValue | 'default'

export type IcpRegisterStepKey = 'register' | 'chooseIcp' | 'recommendation'
